
export default {
  name: "FaqSection",
  props: ['zone'],
  data() {
    return {
      openQuestionIndex: -1, // No question is selected initially
    };
  },
  methods: {
    toggleQuestion(index) {
      // If the question is already open, close it, otherwise open the new one
      this.openQuestionIndex = this.openQuestionIndex === index ? -1 : index;
    },
  },
};
